module.exports = __webpack_public_path__ + "static/media/02-Berlin@3x.978aac29.jpg";